import style from "./style.module.scss";
import close from "../../img/close-circle.svg";

const Modal = (props:{children:any, onClose:Function}) => {

	return (
		<div className={style.modal}>
			<div className={style.window}>
				<img className={style.close} src={close} onClick={()=>{props.onClose()}} alt=""/>
				<div className={style.content}>
					{ props.children }
				</div>
			</div>
		</div>
	);
};

export default Modal;
